module.exports = __webpack_public_path__ + "img/total-express-logo.a9e22d70.png";